module.exports = __webpack_public_path__ + "img/c4c7ee7.png";